const trackEvent = (event, data) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, data);
  }
};

export const trackChatWidgetOpened = () => {
  trackEvent('chat_widget_opened', { widget_type: 'ai-chat', status: 'open' });
};

export const trackContactFormOpened = () => {
  trackEvent('contact_form_opened', { widget_type: 'contact-form', status: 'open' });
};

export const trackChatWidgetClosed = () => {
  trackEvent('chat_widget_closed', { widget_type: 'ai-chat', status: 'close' });
};

export const trackContactFormClosed = () => {
  trackEvent('contact_form_closed', { widget_type: 'contact-form', status: 'close' });
};

export const trackContactFormAbandoned = (formData) => {
  trackEvent('contact_form_abandoned', {
    has_email: !!formData?.email,
    has_name: !!formData?.name,
    has_description: !!formData?.description,
    has_topic: !!formData?.topic,
    has_school: !!formData?.school,
  });
};

export const trackChatTranslationApplied = (language) => {
  trackEvent('chat_translation_applied', {
    language,
  });
};

export const trackChatPromptClicked = (prompt) => {
  trackEvent('chat_prompt_clicked', {
    prompt,
  });
};

export const trackChatMessageSent = (message) => {
  trackEvent('chat_message_sent', {
    message,
  });
};

export const trackChatConversationStarted = (message) => {
  trackEvent('chat_conversation_started', {
    message,
  });
};

export const trackContactFormSubmitted = (formData) => {
  trackEvent('contact_form_submitted', {
    formData,
  });
};

export const trackContactFormSuccess = (formData) => {
  trackEvent('contact_form_success', {
    formData,
  });
};

export const trackContactFormError = (formData, error) => {
  trackEvent('contact_form_error', {
    error_type: error.name || 'UnknownError',
    error_message: error.message,
    has_email: !!formData?.email,
    has_name: !!formData?.name,
    has_topic: !!formData?.topic,
  });
};

export const trackChatResponseViewed = (message) => {
  trackEvent('chat_response_viewed', {
    message,
  });
};
